export default class FinesseCart extends HTMLElement {
  active: boolean = false

  cart: HTMLElement | null = null
  closeButton: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.className = 'fixed top-0 right-[-100vw] flex justify-end z-50 w-full h-full transition-all duration-500'

    this.cart = this.querySelector<HTMLElement>('aside[data-ajax-cart-section]') as HTMLElement
    this.closeButton = this.querySelector<HTMLElement>('button[data-cart-close]') as HTMLElement

    this.closeButton.addEventListener('click', this.handleClose.bind(this))

    this.addEventListener('click', this.handleClose.bind(this)) as any

    (window as any).addEventListener('cart:toggle', this.handleCart.bind(this))
  }

  connectedCallback() {
    // remove hidden from cart section
    if (this.cart) {
      this.cart.classList.remove('hidden')
    }

    // Listen for the "liquid-ajax-cart:request-end" event which is fired after a Shopify Cart API Ajax request is performed
    (document as any).addEventListener('liquid-ajax-cart:request-end', this.handleAjaxCart.bind(this))
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleCart(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleClose(evt: Event) {
    // const isCheckoutButton = (evt.target as HTMLElement).hasAttribute('name') && (evt.target as HTMLElement).getAttribute('name') === 'checkout'
    const isCloseButton = evt.target === this.closeButton || (evt.target as HTMLElement).hasAttribute('data-cart-close')
 
    if (evt.target === this || isCloseButton) {
      evt.preventDefault()
      window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { active: false } }))
    }
  }

  handleAjaxCart(evt: CustomEvent) {
    const { requestState } = evt?.detail

    console.log('handleAjaxCart', evt.detail)

    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      window.dispatchEvent(new CustomEvent('cart:toggle', { bubbles: true, detail: { active: true } }))
    }
  }

  toggle() {
    if (this.isActive) {
      this.classList.add('!right-0')

      document.body.style.overflow = 'hidden'
    } else {
      this.classList.remove('!right-0')

      document.body.style.overflow = 'auto'
    }
  }
}

customElements.define('finesse-cart', FinesseCart)
